// WebSocketContext.tsx - Contexto global para WebSocket
import React, { createContext, useContext, ReactNode } from 'react';
import { Socket } from 'socket.io-client';
import { useWebSocket } from '../hooks/useWebSocket';

interface WebSocketContextType {
    socket: Socket | null;
    isConnected: boolean;
    error: string | null;
    subscribeToPackage: (packageId: string) => void;
    unsubscribeFromPackage: (packageId: string) => void;
    subscribeToCourier: (courierId: string) => void;
    on: (event: string, callback: (...args: any[]) => void) => void;
    off: (event: string, callback?: (...args: any[]) => void) => void;
}

const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined);

export const WebSocketProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const websocket = useWebSocket({ autoConnect: false });

    return (
        <WebSocketContext.Provider value={websocket}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocketContext = () => {
    const context = useContext(WebSocketContext);
    if (context === undefined) {
        throw new Error('useWebSocketContext must be used within a WebSocketProvider');
    }
    return context;
};

export default WebSocketContext;
